<h1 mat-dialog-title>{{ inData.element.performer }} - {{ inData.element.title }} (IMedia : {{ inData.element.imedia }})</h1>
<div mat-dialog-content>
  <p style="color: #3d465a">Edition champ Propriétés</p>
  <mat-form-field class="proprietes-chip-list" style="width:100%">
    <mat-chip-grid #chipList aria-label="Champ propriétés">
      <mat-chip-row
        *ngFor="let propriete of proprietes"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(propriete)">
        {{propriete}}
        <mat-icon svgIcon="cancel" *ngIf="removable" matChipRemove></mat-icon>
      </mat-chip-row>
      <input
        placeholder="Champ propriétés"
        #proprieteInput
        [formControl]="proprieteCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)">
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngFor="let propriete of filteredProprietes | async" [value]="propriete">
        {{propriete}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <p style="color: #3d465a">Edition champ Mood 3</p>
  <mat-form-field appearance="fill">
    <mat-label>Mood 3</mat-label>
    <mat-select [(value)]="selectedMood3">
      <mat-option>None</mat-option>
      <mat-option value="Groovy">Groovy</mat-option>
      <mat-option value="Happy">Happy</mat-option>
      <mat-option value="Happy Club">Happy Club</mat-option>
      <mat-option value="Insolite">Insolite</mat-option>
      <mat-option value="Kitch">Kitch</mat-option>
      <mat-option value="Neutre">Neutre</mat-option>
      <mat-option value="Slowly">Slowly</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div mat-dialog-actions>
  <button style="color: #3d465a" mat-button (click)="edit(false)">Annuler</button>
  <button style="color: #3d465a" mat-button (click)="edit(true)" cdkFocusInitial>Ok</button>
</div>
